module.exports = __webpack_public_path__ + "static/media/navMenuBG.c57ce2af.jpg";